module.exports = __webpack_public_path__ + "static/image1-83d05581687a0952618aabc1ddfddaa2.jpg";